// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faBell, faCog, faEnvelopeOpen, faSearch, faSignOutAlt, faUserShield } from "@fortawesome/free-solid-svg-icons";
// import { faUserCircle } from "@fortawesome/free-regular-svg-icons";
// import { Row, Col, Nav, Form, Image, Navbar, Dropdown , Alert, Container, ListGroup, InputGroup } from '@themesberg/react-bootstrap';
// import NOTIFICATIONS_DATA from "../data/notifications";
// import DefaultProfile from "../assets/img/team/profile-picture-3.jpg";
// import { useAuth } from "../AuthContext";
// import { useNavigate } from "react-router-dom";
// import { Routes } from "../routes";
import { getImageUrl } from "../utils/imageUrl";
import AxiosInstance from "../AxiosInstance";
// import Profile1 from "../assets/img/team/profile-picture-1.jpg";
// export default () => {
//   const [notifications, setNotifications] = useState(NOTIFICATIONS_DATA);
//   const [user, setUser] = useState({ nom: "", photo: "" });
//   const { logout } = useAuth();       // récupère la fonction logout
//   const navigate = useNavigate();    // permet la redirection

//   const areNotificationsRead = notifications.reduce((acc, notif) => acc && notif.read, true);
//   const [userData, setUserData] = useState(null);
//   const [formData, setFormData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [editing, setEditing] = useState(false);
//   const [error, setError] = useState(null);
//   const [saving, setSaving] = useState(false);
//   const [successMessage, setSuccessMessage] = useState(null);
//   const [avatarPreview, setAvatarPreview] = useState(null); // URL pour afficher l'avatar temporaire

//   useEffect(() => {
//     const fetchUser = async () => {
//       try {
//         const token = localStorage.getItem("token");
//         if (!token) {
//           setError("Utilisateur non authentifié.");
//           setLoading(false);
//           return;
//         }

//         const response = await fetch("https://api.wemaza.com/api/users/profile", {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         });

//         if (!response.ok) {
//           const text = await response.text();
//           throw new Error(`Erreur serveur: ${response.status} - ${text}`);
//         }

//         const data = await response.json();
//         const user = data.user || data;

//         const initialUserData = {
//           name: user.name || "",
//           email: user.email || "",
//           phone: user.phone || "",
//           location: user.location || "",
//           role: user.role || "",
//           avatar: user.avatar || null,
//         };

//         setUserData(initialUserData);
//         setFormData(initialUserData);
//         setAvatarPreview(initialUserData.avatar ? `https://api.wemaza.com/${initialUserData.avatar}` : Profile1);
//       } catch (err) {
//         console.error("Erreur API:", err);
//         setError("  ");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchUser();
//   }, []);


//   if (error) return <Alert variant="danger">{error}</Alert>;
//   if (!userData) return null;

//   // Gestion des champs modifiables
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   // Gestion de l'upload avatar
//   const handleAvatarChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setFormData((prev) => ({ ...prev, avatar: file }));
//       setAvatarPreview(URL.createObjectURL(file));
//     }
//   };

//   // Annuler modifications
//   const handleCancel = () => {
//     setFormData(userData);
//     setAvatarPreview(userData.avatar ? getImageUrl(userData.avatar) : Profile1);
//     setEditing(false);
//     setError(null);
//     setSuccessMessage(null);
//   };

//   const handleSave = async () => {
//     setSaving(true);
//     setError(null);
//     setSuccessMessage(null);

//     try {
//       const token = localStorage.getItem("token");
//       if (!token) {
//         setError("Utilisateur non authentifié.");
//         setSaving(false);
//         return;
//       }

//       let body;
//       let headers = { Authorization: `Bearer ${token}` };

//       if (formData.avatar instanceof File) {
//         body = new FormData();
//         body.append("name", formData.name);
//         body.append("phone", formData.phone);
//         body.append("location", formData.location);
//         body.append("avatar", formData.avatar);
//       } else {
//         headers["Content-Type"] = "application/json";
//         body = JSON.stringify({
//           name: formData.name,
//           phone: formData.phone,
//           location: formData.location,
//           avatar: formData.avatar,
//         });
//       }

//       const response = await fetch("https://api.wemaza.com/api/users/profile", {
//         method: "PUT",
//         headers,
//         body,
//       });

//       if (!response.ok) {
//         const text = await response.text();
//         throw new Error(`Erreur serveur: ${response.status} - ${text}`);
//       }

//       // ✅ Re-fetch à jour
//       const refreshed = await fetch("https://api.wemaza.com/api/users/profile", {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//       });

//       if (!refreshed.ok) {
//         const text = await refreshed.text();
//         throw new Error(`Erreur serveur: ${refreshed.status} - ${text}`);
//       }

//       const newData = await refreshed.json();
//       const user = newData.user || newData;

//       const updated = {
//         name: user.name || "",
//         email: user.email || "",
//         phone: user.phone || "",
//         location: user.location || "",
//         role: user.role || "",
//         avatar: user.avatar || null,
//       };

//       setUserData(updated);
//       setFormData(updated);
//       setAvatarPreview(updated.avatar ? getImageUrl(updated.avatar) : Profile1);
//       setSuccessMessage("Profil mis à jour avec succès !");
//       setEditing(false);
//     } catch (err) {
//       console.error("Erreur API lors de la sauvegarde:", err);
//       setError("Erreur lors de la mise à jour du profil.");
//     } finally {
//       setSaving(false);
//     }
//   };


//   if (loading || !userData) return null;


//   const Notification = ({ link, sender, image, time, message, read = false }) => {
//     const readClassName = read ? "" : "text-danger";

//     return (
//       <ListGroup.Item action href={link} className="border-bottom border-light">
//         <Row className="align-items-center">
//           <Col className="col-auto">
//             <Image src={image} className="user-avatar lg-avatar rounded-circle" />
//           </Col>
//           <Col className="ps-0 ms--2">
//             <div className="d-flex justify-content-between align-items-center">
//               <div>
//                 <h4 className="h6 mb-0 text-small">{sender}</h4>
//               </div>
//               <div className="text-end">
//                 <small className={readClassName}>{time}</small>
//               </div>
//             </div>
//             <p className="font-small mt-1 mb-0">{message}</p>
//           </Col>
//         </Row>
//       </ListGroup.Item>
//     );
//   };

//   return (
//     <Navbar variant="dark" expanded className="ps-0 pe-2 pb-0">
//       <Container fluid className="px-0">
//         <div className="d-flex justify-content-between w-100">
//           <div className="d-flex align-items-center">
//             {/* <Form className="navbar-search">
//               <Form.Group id="topbarSearch">
//                 <InputGroup className="input-group-merge search-bar">
//                   <InputGroup.Text><FontAwesomeIcon icon={faSearch} /></InputGroup.Text>
//                   <Form.Control type="text" placeholder="Search" />
//                 </InputGroup>
//               </Form.Group>
//             </Form> */}
//           </div>
//           <Nav className="align-items-center">
//             {/* <Dropdown as={Nav.Item} onToggle={markNotificationsAsRead}>
//               <Dropdown.Toggle as={Nav.Link} className="text-dark icon-notifications me-lg-3">
//                 <span className="icon icon-sm">
//                   <FontAwesomeIcon icon={faBell} className="bell-shake" />
//                   {!areNotificationsRead && <span className="icon-badge rounded-circle unread-notifications" />}
//                 </span>
//               </Dropdown.Toggle>
//               <Dropdown.Menu className="dashboard-dropdown notifications-dropdown dropdown-menu-lg dropdown-menu-center mt-2 py-0">
//                 <ListGroup className="list-group-flush">
//                   <Nav.Link href="#" className="text-center text-primary fw-bold border-bottom border-light py-3">
//                     Notifications
//                   </Nav.Link>

//                   {notifications.map(n => <Notification key={`notification-${n.id}`} {...n} />)}

//                   <Dropdown.Item className="text-center text-primary fw-bold py-3">
//                     View all
//                   </Dropdown.Item>
//                 </ListGroup>
//               </Dropdown.Menu>
//             </Dropdown> */}

//             <Dropdown as={Nav.Item}>
//               <Dropdown.Toggle as={Nav.Link} className="pt-1 px-0">
//                 <div className="media d-flex align-items-center">
//                   <Image
//                   src={
//                     userData.avatar
//                       ? `https://api.wemaza.com/${userData.avatar}`
//                       : Profile1
//                   }

//                     // src={user.photo ? user.photo : DefaultProfile}
//                     className="user-avatar md-avatar rounded-circle"
//                     alt="Profil"
//                   />
//                   <div className="media-body ms-2 text-dark align-items-center d-none d-lg-block">
//                     <span className="mb-0 font-small fw-bold">{userData.name}</span>
//                   </div>
//                 </div>
//               </Dropdown.Toggle>
//               <Dropdown.Menu className="user-dropdown dropdown-menu-right mt-2">
//                 <Dropdown.Item className="fw-bold">
//                   <FontAwesomeIcon icon={faUserCircle} link={Routes.Settings.path}  /> Mon Profil
//                 </Dropdown.Item>


//                 <Dropdown.Divider />
//                 <Dropdown.Item
//                   className="fw-bold text-danger"
//                   onClick={() => {
//                     logout();            // appel de la fonction pour vider les données
//                     navigate("/");  // redirection vers la page de login
//                   }}
//                 >
//                   <FontAwesomeIcon icon={faSignOutAlt} className="me-2" />
//                   Se déconnecter
//                 </Dropdown.Item>

//               </Dropdown.Menu>
//             </Dropdown>
//           </Nav>
//         </div>
//       </Container>
//     </Navbar>
//   );
// };






import React, { useState, useEffect } from "react";
import {
  Row, Col, Nav, Form, Image, Navbar, Dropdown,
  Alert, Container, ListGroup, InputGroup
} from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBell, faCog, faEnvelopeOpen, faSignOutAlt, faUserShield,
  faSearch
} from "@fortawesome/free-solid-svg-icons";
import { faUserCircle } from "@fortawesome/free-regular-svg-icons";
import DefaultProfile from "../assets/img/team/profile-picture-3.jpg";
import Profile1 from "../assets/img/team/profile-picture-1.jpg";
import NOTIFICATIONS_DATA from "../data/notifications";
import { useAuth } from "../AuthContext";
import { useNavigate } from "react-router-dom";
import { Routes } from "../routes";

export default () => {
  const [notifications, setNotifications] = useState(NOTIFICATIONS_DATA);
  const [userData, setUserData] = useState(null);
  const [formData, setFormData] = useState(null);
  const [avatarPreview, setAvatarPreview] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);
  const [editing, setEditing] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);

  const { logout } = useAuth();
  const navigate = useNavigate();

  const areNotificationsRead = notifications.every(n => n.read);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await AxiosInstance.get("/api/users/profile");
        const user = res.data?.user || res.data;

        const userInfo = {
          name: user.name || "",
          email: user.email || "",
          phone: user.phone || "",
          location: user.location || "",
          role: user.role || "",
          avatar: user.avatar || null
        };

        setUserData(userInfo);
        setFormData(userInfo);
        setAvatarPreview(userInfo.avatar ? getImageUrl(userInfo.avatar) : Profile1);
      } catch (err) {
        console.error("Erreur API:", err);
        setError("Erreur lors du chargement des données utilisateur.");
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleAvatarChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData(prev => ({ ...prev, avatar: file }));
      setAvatarPreview(URL.createObjectURL(file));
    }
  };

  const handleCancel = () => {
    setFormData(userData);
    setAvatarPreview(userData.avatar ? getImageUrl(userData.avatar) : Profile1);
    setEditing(false);
    setSuccessMessage(null);
    setError(null);
  };

  const handleSave = async () => {
    setSaving(true);
    setError(null);
    setSuccessMessage(null);

    try {
      let headers = {};
      let body;

      if (formData.avatar instanceof File) {
        body = new FormData();
        body.append("name", formData.name);
        body.append("phone", formData.phone);
        body.append("location", formData.location);
        body.append("avatar", formData.avatar);
      } else {
        headers["Content-Type"] = "application/json";
        body = {
          name: formData.name,
          phone: formData.phone,
          location: formData.location,
          avatar: formData.avatar
        };
      }

      await AxiosInstance.put("/api/users/profile", body, { headers });

      const refresh = await AxiosInstance.get("/api/users/profile");
      const user = refresh.data?.user || refresh.data;

      const updated = {
        name: user.name || "",
        email: user.email || "",
        phone: user.phone || "",
        location: user.location || "",
        role: user.role || "",
        avatar: user.avatar || null,
      };

      setUserData(updated);
      setFormData(updated);
      setAvatarPreview(updated.avatar ? getImageUrl(updated.avatar) : Profile1);
      setSuccessMessage("Profil mis à jour avec succès !");
      setEditing(false);
    } catch (err) {
      console.error("Erreur API:", err);
      setError("Erreur lors de la mise à jour.");
    } finally {
      setSaving(false);
    }
  };

  const Notification = ({ link, sender, image, time, message, read = false }) => {
    const readClass = read ? "" : "text-danger";
    return (
      <ListGroup.Item action href={link} className="border-bottom border-light">
        <Row className="align-items-center">
          <Col className="col-auto">
            <Image src={image} className="user-avatar lg-avatar rounded-circle" />
          </Col>
          <Col className="ps-0 ms--2">
            <div className="d-flex justify-content-between align-items-center">
              <h4 className="h6 mb-0 text-small">{sender}</h4>
              <small className={readClass}>{time}</small>
            </div>
            <p className="font-small mt-1 mb-0">{message}</p>
          </Col>
        </Row>
      </ListGroup.Item>
    );
  };

  if (loading || !userData) return null;

  return (
    <Navbar variant="dark" expanded className="ps-0 pe-2 pb-0">
      <Container fluid className="px-0">
        <div className="d-flex justify-content-between w-100">
          <div></div>
          <Nav className="align-items-center">
            <Dropdown as={Nav.Item}>
              <Dropdown.Toggle as={Nav.Link} className="pt-1 px-0">
                <div className="media d-flex align-items-center">
                  <Image
                    src={avatarPreview}
                    className="user-avatar md-avatar rounded-circle"
                    alt="Profil"
                  />
                  <div className="media-body ms-2 text-dark d-none d-lg-block">
                    <span className="mb-0 font-small fw-bold">{userData.name}</span>
                  </div>
                </div>
              </Dropdown.Toggle>
              <Dropdown.Menu className="user-dropdown dropdown-menu-right mt-2">

                <Dropdown.Item
                  className="fw-bold"
                  onClick={() => navigate("/profil")}
                >
                  <FontAwesomeIcon icon={faUserCircle} className="me-2" /> Mon Profil
                </Dropdown.Item>

                <Dropdown.Divider />
                <Dropdown.Item
                  className="fw-bold text-danger"
                  onClick={() => {
                    logout();
                    navigate("/");
                  }}
                >
                  <FontAwesomeIcon icon={faSignOutAlt} className="me-2" />
                  Se déconnecter
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </div>
      </Container>
    </Navbar>
  );
};



